<div class="row">
    <div class="container-fluid pl-0 pr-0">
        <div class="row">
            <div class="col-xl-12">
                <div class="card card-header-actions mx-auto">
                    <div class="card-header">
                        {{showDetails ?'MMU Workforce Performance Overview':'Employee Performance by MMU'}}
                        <button class="btn btn-blue btn-icon float-right" (click)="goBackCheck()">
                            <i class="fa fa-arrow-left"></i>
                        </button>
                    </div>
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-xl-3">
                                <label class="control-label">{{EnableHumanMMU ? 'MMU' : 'MVU'}}<span
                                        class="text-danger">*</span></label>
                                <div>
                                    <select class="form-control form-control-sm" [(ngModel)]="MVU"
                                        [ngModelOptions]="{standalone: true}">
                                        <option value="">Select</option>
                                        <!-- <option value="-1">All</option> -->
                                        <option *ngFor="let item of mvuLst" [value]="item.mvu_id">
                                            {{item.mvu_name}}</option>
                                    </select>
                                    <!-- <div *ngIf="submitted && f.work_location_id.errors" class="invalid-feedback">
                                            <div *ngIf="f.work_location_id.errors.required"> {{EnableHumanMMU ? 'MMU' :
                                                'MVU'}} is required
                                            </div>
                                        </div> -->
                                </div>
                            </div>
                            <div class='col-xl-2'>
                                <div class="form-group">
                                    <div class='date' id='datetimepicker6'>
                                        <label class="control-label">From Date<span class="text-danger">*</span>
                                        </label>
                                        <div>
                                            <input id="start_date" name="start_date" type="text" autocomplete="off"
                                                onpaste="return false" placeholder="From" bsDatepicker
                                                #dp="bsDatepicker" (focus)="dp.show()" [(ngModel)]="start_date"
                                                [ngModelOptions]="{standalone:true}" [minDate]="d2Day"
                                                [maxDate]="max_date" onkeypress='return event.charCode == 8'
                                                [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false , minMode: 'month'}"
                                                class="form-control form-control-sm">
                                            <!-- <div *ngIf="submitted && f.start_date.errors" class="invalid-feedback">
                                                <div *ngIf="f.start_date.errors.required">From Date is required</div>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class='col-xl-2'>
                                <div class="form-group">
                                    <div class='date' id='datetimepicker6'>
                                        <label class="control-label">To Date<span class="text-danger">*</span>
                                        </label>
                                        <div>
                                            <input id="end_date" name="end_date" type="text" autocomplete="off"
                                                onpaste="return false" placeholder="From" bsDatepicker
                                                #dp="bsDatepicker" (focus)="dp.show()" [(ngModel)]="end_date"
                                                [ngModelOptions]="{standalone:true}" [minDate]="start_date"
                                                [maxDate]="max_date" onkeypress='return event.charCode == 8'
                                                [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false , minMode: 'month'}"
                                                class="form-control form-control-sm">
                                            <!-- <div *ngIf="submitted && f.start_date.errors" class="invalid-feedback">
                                                <div *ngIf="f.start_date.errors.required">From Date is required</div>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class='col-md-4' style="margin-top: 2rem;">
                                <button type="submit" class="btn btn-sm btn-primary" value="Submit"
                                    (click)="onSubmit();showDetails=false">Submit</button>&nbsp;&nbsp;
                                    <button type="submit" class="btn btn-sm btn-primary" value="Submit"
                                    (click)="LoadData();showDetails=true">View Details</button>&nbsp;&nbsp;
                                    <button type="submit" class="btn btn-sm btn-secondary" value="Excel" title="All MMU with employee Details"
                                        (click)="ExportExcel()"> <i class="fas fa-file-excel"></i>&nbsp;&nbsp;Excel</button>
                            </div>
                        </div>
                        <div class="d-flex justify-content-end align-items-center mb-2">
                            <button class="btn btn-sm btn-danger mr-2" (click)="openDeductionModal(null,false)">
                                <i class="fa fa-plus"></i>&nbsp;Add Deduction
                            </button>
                            <button class="btn btn-sm btn-success" (click)="openIncentives(null,false)">
                                <i class="fa fa-plus"></i>&nbsp;Add Incentive
                            </button>
                        </div>
                        
                      
                    <div style="font-size: small;" *ngIf="showDetails">
                    
                        <div *ngFor="let role of finalRoles">
                    
                            <!-- 🔴 DEDUCTION SECTION -->
                            <h3 class="text-danger">
                                {{ role.roleName | titlecase}} - Deduction
                            </h3>
                    
                            <table *ngIf="role.deductions?.length > 0" class="table table-striped table-bordered table-sm" datatable>
                    
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>S.No</th>
                                        <th>Date</th>
                                        <th>User Name</th>
                                        <th>KRA</th>
                                        <th>KPI</th>
                                        <th>Target</th>
                                        <!-- <th>Target Amount</th> -->
                                        <th>Amount</th>
                                        <th>Block</th>
                                        <th>Reason</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                    
                                <tbody>
                                    <tr *ngFor="let item of role.deductions; let i = index">
                                        <td  class="text-center">
                                            <input type="checkbox" class="mt-2" [(ngModel)]="item.isSelected" (change)="toggleRow(item)">
                                        </td>
                                        <td>{{ i + 1 }}</td>
                                        <td style="white-space: nowrap;">
                                            {{ item.createdOn | date:'dd-MM-yyyy' }}
                                        </td>
                                        <td style="white-space: nowrap;">{{ item.userName }}</td>
                                        <td>{{ item.kraName }}</td>
                                        <td>{{ item.kpiName }}</td>
                                        <td>{{ item.targetName }}</td>
                                        <!-- <td>{{ item.targetTypeId }}</td> -->
                                        <!-- <td>{{ item.deductionAmount }}</td> -->
                    
                                        <td>
                                            <input type="number" class="form-control form-control-sm" [(ngModel)]="item.deductionAmount"
                                                [disabled]="!item.isSelected">
                                            <!-- ❌ VALIDATION -->
                                            <small class="text-danger" *ngIf="item.isSelected && (!item.deductionAmount && item.deductionAmount !== 0)">
                                                Amount required
                                            </small>
                                        </td>
                    
                                        <td class="text-center">
                                            <input type="checkbox" class="mt-2" [(ngModel)]="item.isBlock" [disabled]="!item.isSelected">
                                        </td>

                                        <!-- Remarks: textarea when blocked, dash otherwise -->
                                        <td>
                                          <ng-container *ngIf="item.isBlock && item.isSelected">
                                            <textarea class="form-control form-control-sm"
                                                      rows="1" cols="20"
                                                      placeholder="Enter reason *"
                                                      [(ngModel)]="item.remarks"
                                                      maxlength="250"
                                                      style="min-width:160px;resize:vertical;">
                                            </textarea>
                                            <small class="text-danger" *ngIf="item.isBlock && item.isSelected && !item.remarks">
                                              Reason is mandatory
                                            </small>
                                          </ng-container>
                                          <span *ngIf="!item.isBlock || !item.isSelected">{{item.remarks}}</span>
                                        </td>

                                        <td>
                                            <!-- <div class="badge badge-info badge-pill pointer">
                                             <a (click)="modalTitle='Edit Deduction'; openDeductionModal(item,true)">
                                                <i class="fa fa-edit text-white"></i>
                                             </a>
                                            </div> -->
                                            <button *ngIf="item.isSelected" [disabled]="!item.deductionAmount" class="btn btn-sm btn-success" (click)="submitDeduction2(item)">Save </button>
                                        </td>
                    
                                    </tr>
                                </tbody>
                                <tfoot *ngIf="role.deductions?.length > 0">
                                    <tr class="fw-bold bg-light">
                                        <td colspan="7" class="text-end">Total</td>
                                
                                        <td class="text-danger fw-bold">
                                            <b>₹{{ getDeductionTotal(role) }}</b>
                                        </td>
                                
                                        <td colspan="3"></td>
                                    </tr>
                                </tfoot>
                                
                                </table>
                    
                            <p *ngIf="!role.deductions || role.deductions.length === 0">
                                No Deduction Records
                            </p>
                    
                    
                            <!-- 🟢 INCENTIVE SECTION -->
                            <h3 class="text-success">
                                {{ role.roleName | titlecase }} - Incentives
                            </h3>
                    
                            <table *ngIf="role.incentives?.length > 0" class="table table-striped table-bordered table-sm" datatable
                                style="white-space: nowrap;">
                    
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>S.No</th>
                                        <th>Date</th>
                                        <th>User Name</th>
                                        <th>Description</th>
                                        <th>Amount</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                    
                                <tbody>
                                    <tr *ngFor="let item of role.incentives; let i = index">
                                         <td class="text-center">
                                            <input type="checkbox" class="mt-2" [(ngModel)]="item.isSelected" (change)="toggleIncentiveRow(item)">
                                        </td>
                                        <td>{{ i + 1 }}</td>
                                        <td style="white-space: nowrap;">
                                            {{ item.createdOn | date:'dd-MM-yyyy' }}
                                        </td>
                                        <td style="white-space: nowrap;">{{ item.userName }}</td>
                    
                                        <td class="wrap-text">
                                            {{ item.description }}
                                        </td>
                    
                                        <!-- <td>{{ item.incentiveAmount }}</td> -->
                                         <td>
                                          <input type="number" class="form-control form-control-sm" [(ngModel)]="item.incentiveAmount"
                                                [disabled]="!item.isSelected">
                                            <!-- ❌ VALIDATION -->
                                            <small class="text-danger" *ngIf="item.isSelected && (!item.incentiveAmount && item.incentiveAmount !== 0)">
                                                Amount required
                                            </small>
                                         </td>
                    
                                        <td>
                                            <!-- <div class="badge badge-info badge-pill pointer">
                                                <a (click)="modalTitle='Edit Incentives'; openIncentives(item,true)">
                                                    <i class="fa fa-edit text-white"></i>
                                                </a>
                                            </div> -->
                                             <button *ngIf="item.isSelected" [disabled]="!item.incentiveAmount" class="btn btn-sm btn-success" (click)="incentivesSubmit2(item)">Save </button>
                                        </td>
                    
                                    </tr>
                                    </tbody>
                                    <tfoot *ngIf="role.incentives?.length > 0">
                                        <tr class="fw-bold bg-light">
                                            <td colspan="5" class="text-end">Total</td>
                                    
                                            <td class="text-success fw-bold">
                                                <b>₹{{ getIncentiveTotal(role) }}</b>
                                            </td>
                                    
                                            <td></td>
                                        </tr>
                                    </tfoot>
                                    
                                    </table>
                            <p *ngIf="!role.incentives || role.incentives.length === 0">
                                No Incentive Records
                            </p>
                    
                        </div>
                    
                    </div>
                    <div style="font-size: small;" *ngIf="!showDetails">
                        <table datatable *ngIf="dtRender1" class="table table-striped table-bordered table-sm">
                    
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>{{EnableHumanMMU ? 'MMU' : 'MVU'}} Name</th>
                                    <th>User Name</th>
                                    <th>Role</th>
                                    <th>Incentive Count</th>
                                    <th>Deduction Count</th>
                                    <th>Total Incentive (₹)</th>
                                    <th>Total Deduction (₹)</th>
                                    <th>Net Amount (₹)</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                    
                            <tbody>
                    
                                <tr *ngFor="let user of summaryList; let i = index">
                                    <td>{{ i + 1 }}</td>
                                    <td>{{user?.mvuName}}</td>
                                    <td>{{ user.userName }}</td>
                                    <td>{{ user.roleName | titlecase }}</td>
                                    <td class="text-right">{{ user.incentiveCount }}</td>
                                    <td class="text-right">{{ user.deductionCount }}</td>
                                    <td class="text-right text-success">₹{{ user.totalIncentive }}</td>
                                    <td class=" text-right text-danger">₹{{ user.totalDeduction }}</td>
                                    <td class="text-right" [ngClass]="{'text-success': user.netAmount >= 0,'text-danger': user.netAmount < 0}"> ₹{{ user.netAmount }} </td>
                                    
                    
                                    <td class="text-center" style="white-space: nowrap;">
                                       <i class="fa fa-eye text-blue" style="cursor: pointer;" (click)="viewDetails(user)"></i>
                                    </td>
                                </tr>
                    
                            </tbody>
                    
                            <!-- ✅ FOOTER instead of tbody row (better for DataTable) -->
                            <tfoot *ngIf="summaryList.length>0">
                                <tr class="fw-bold bg-light">
                                    <td colspan="4">TOTAL</td>
                                    <td class="text-right"><b>{{ summaryTotals.incentiveCount }}</b></td>
                                    <td  class="text-right"><b>{{ summaryTotals.deductionCount }}</b></td>
                                    <td class="text-success text-right"><b>₹{{ summaryTotals.totalIncentive }}</b></td>
                                    <td class=" text-right text-danger"><b>₹{{ summaryTotals.totalDeduction }}</b></td>
                                    <td [ngClass]="{'text-success text-right': summaryTotals.netAmount >= 0,'text-danger text-right': summaryTotals.netAmount < 0}">
                                        <b>₹{{ summaryTotals.netAmount }}</b>
                                    </td>
                    
                                    
                                    <td></td>
                                </tr>
                            </tfoot>
                    
                        </table>
                    </div>
                    
                    </div>
                    </div>
                    </div>
        </div>
    </div>
</div>

<div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" 
  id="deduction" role="dialog" aria-labelledby="edit">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{modalTitle}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
    <div class="container-fluid" [formGroup] ="deductionForm">
        <div class="row">
        <div class="col-xl-3">
            <div class="form-group">
                <label class="control-label">User Name <span class="text-danger">*</span> </label>
                <div>
                    <select id="roleId" class="form-control form-control-sm" formControlName="roleId"
                        (change)="getKRA($event.target.value)"
                         [ngClass]="{ 'is-invalid': submitted && f.roleId.errors }">
                        <option value="">Select</option>
                        <!-- <option value="-1">All</option> -->
                        <option *ngFor="let role of roleList" [value]="role.role_id">
                          {{role.user_name}} - {{role.role_name}}</option>
                    </select>
                    <div *ngIf="submitted && f.roleId.errors" class="invalid-feedback">
                     <div *ngIf="f.roleId.errors.required">User Name is required</div>
                     </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3">
            <div class="form-group">
                <label class="control-label">KRA <span class="text-danger">*</span> </label>
                <div>
                    <select id="kraId" class="form-control form-control-sm" formControlName="kraId"
                        (change)="getKPI($event.target.value)"
                        [ngClass]="{ 'is-invalid': submitted && f.kraId.errors }">
                        <option value="">Select</option>
                        <!-- <option value="-1">All</option> -->
                        <option *ngFor="let item of kraList" [value]="item.id">
                            {{item.kra_type}}</option>
                    </select>
                    <div *ngIf="submitted && f.kraId.errors" class="invalid-feedback">
                     <div *ngIf="f.kraId.errors.required">KRA is required</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3">
            <div class="form-group">
                <label class="control-label">KPI <span class="text-danger">*</span> </label>
                <div>
                    <select id="kpiId" class="form-control form-control-sm" formControlName="kpiId"
                       (change)="getTargetTypes($event.target.value)" 
                       [ngClass]="{ 'is-invalid': submitted && f.kpiId.errors }">
                        <option value="">Select</option>
                        <!-- <option value="-1">All</option> -->
                        <option *ngFor="let item of kpiList" [value]="item.id">
                            {{item.kpi_type}}</option>
                    </select>
                    <div *ngIf="submitted && f.kpiId.errors" class="invalid-feedback">
                     <div *ngIf="f.kpiId.errors.required">KPI is required</div>
                      </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3">
            <div class="form-group">
                <label class="control-label">Target Type <span class="text-danger">*</span> </label>
                <div>
                    <select id="targetTypeId" class="form-control form-control-sm" formControlName="targetTypeId"
                        (change)="getRules($event.target.value)"
                        [ngClass]="{ 'is-invalid': submitted && f.roleId.errors }">
                        <option value="">Select</option>
                        <!-- <option value="-1">All</option> -->
                        <option *ngFor="let item of targetTypeList" [value]="item.id">
                            {{item.target_type}}</option>
                    </select>
                    <div *ngIf="submitted && f.targetTypeId.errors" class="invalid-feedback">
                    <div *ngIf="f.targetTypeId.errors.required">Target Type is required</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3">
          <div class="form-group">
                                    <div class='date' id='datetimepicker6'>
                                        <label class="control-label">Date<span class="text-danger">*</span></label>
                                        <div>
                                            <input id="createdOn" name="createdOn" type="text" autocomplete="off"
                                            onpaste="return false" placeholder="DD-MM-YYYY" bsDatepicker
                                            #dp="bsDatepicker" formControlName="createdOn" [maxDate]="d2Day"
                                            [placeholder]="'DD-MM-YYYY'" onkeypress='return event.charCode == 8'
                                            [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false }"
                                            class="form-control form-control-sm">

                                        </div>
                                    </div>
                                </div>
        </div>
        <div class="col-xl-3">
            <div class="form-group">
                    <label class="control-label"> Status <span class="text-danger">*</span></label>
                    <div style="cursor: pointer;">
                        <input type="radio" id="block" formControlName="isBlock" [value]="true">
                        <label for="block"> &nbsp;Block</label> &nbsp;&nbsp;
                        
                        <input type="radio" id="unblock" formControlName="isBlock" [value]="false">
                        <label for="unblock"> &nbsp;Un Block</label>
                        </div>
                        </div>
        </div>
        <div class="col-xl-3" *ngIf="deductionForm.get('isBlock')?.value">
          <label class="control-label">Reason<span class="text-danger">*</span></label>
          <div>
            <textarea nameFormatter class="form-control form-control-sm" placeholder="Enter Reason" autocomplete="off" id="reason"
              cols="2" rows="2" maxlength="250" formControlName="remarks"
              [ngClass]="{ 'is-invalid': submitted && f.remarks.errors }">
                                       </textarea>
            <div *ngIf="submitted && f.remarks.errors" class="invalid-feedback">
              <div *ngIf="f.remarks.errors.required">--Please enter reason</div>
            </div>
          </div>

        </div>
     
      </div>
     <div class="row mt-3">
  <div class="col-12">
    <div class="card p-3 shadow-sm">
      <h6 class="mb-3">Rules</h6>
      <div class="row">
        <!-- Normal Email -->
        <div class="col-md-2">
          <label class="fw-bold">Normal Email</label><br>
          <label class="me-2">
            <input type="radio" name="normalEmail" checked disabled> Yes
          </label> &nbsp;
          <label>
            <input type="radio" name="normalEmail" disabled> No
          </label>
        </div>

        <!-- Monthly Warning -->
        <div class="col-md-2">
          <label class="fw-bold">Monthly Warning</label><br>
          <label class="me-2">
            <input type="radio" name="monthlyWarning" checked disabled> Yes
          </label>&nbsp;
          <label>
            <input type="radio" name="monthlyWarning" disabled> No
          </label>
        </div>

        <!-- Triggered Days -->
        <div class="col-md-3">
          <label class="fw-bold">Triggered Days</label>
          <input type="number" class="form-control form-control-sm mt-1" [(ngModel)]="triggered_days" 
          [ngModelOptions]="{standalone : true}" disabled>
        </div>

        <!-- Deduction Email -->
        <div class="col-md-2">
          <label class="fw-bold">Deduction Email</label><br>
          <label class="me-2">
            <input type="radio" name="deductionEmail"  value="Yes" checked disabled> Yes
          </label>&nbsp;
          <label>
            <input type="radio" name="deductionEmail"  value="No" disabled> No
          </label>
        </div>

        <!-- Amount -->
        <div class="col-md-3">
          <label class="fw-bold">Amount <span class="text-danger">*</span> </label>
          <input type="number"
                 class="form-control form-control-sm"
                 formControlName = "deductionAmount"
                 [ngClass]="{ 'is-invalid': submitted && f.deductionAmount.errors }">
                 <div *ngIf="submitted && f.deductionAmount.errors" class="invalid-feedback">
                    <div *ngIf="f.deductionAmount.errors.required">Amount is required</div>
                    </div>
        </div>
         

      </div>

    </div>
  </div>
</div>
      </div>
       </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-success" (click)="submitDeduction()">Save</button>
        <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
  </div>
<div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" 
  id="incentives" role="dialog"  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{modalTitle}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
    <div class="container-fluid" >
          <div class="row" [formGroup]="incentiveForm">
        <div class="col-xl-3">
            <div class="form-group">
                <label class="control-label">User Name <span class="text-danger">*</span> </label>
                <div>
                    <select id="roleId" class="form-control form-control-sm" formControlName="userId"
                        [ngClass]="{ 'is-invalid': submitted && g.userId.errors }" (change)="getUserName($event.target.value)">
                        <option value="">Select</option>
                        <option *ngFor="let role of roleList" [value]="role.user_id">
                             {{role.user_name}} - {{role.role_name}}</option>
                    </select>
                    <div *ngIf="submitted && g.userId.errors" class="invalid-feedback">
                    <div *ngIf="g.userId.errors.required">User Name is required</div>
                    </div>
                </div>
            </div>
        </div>
                <div class="col-xl-3">
            <div class="form-group">
                <div class='date' id='datetimepicker6'>
                    <label class="control-label">Date<span class="text-danger">*</span></label>
                    <div>
                        <input id="createdOn" name="createdOn" type="text" autocomplete="off" onpaste="return false"
                            placeholder="DD-MM-YYYY" bsDatepicker #dp="bsDatepicker" formControlName="createdOn" 
                            [maxDate]="d2Day" [placeholder]="'DD-MM-YYYY'" onkeypress='return event.charCode == 8'
                            [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false }"
                            class="form-control form-control-sm">
    
                    </div>
                </div>
            </div>
        </div>
           <div class="col-xl-3">
            <div class="form-group">
                <label class="control-label">Slab  <span class="text-danger">*</span> </label>
                <div>
                    <select id="targetTypeId" class="form-control form-control-sm" 
                        formControlName="slabId"  [ngClass]="{ 'is-invalid': submitted && g.slabId.errors }"
                        (change)="changeSlab($event.target.value)">
                        <option value="">Select</option>
                        <!-- <option value="-1">All</option> -->
                        <option *ngFor="let item of slabsList" [value]="item.id">
                            {{item.slab_type}}</option>
                    </select>
                    <div *ngIf="submitted && g.slabId.errors" class="invalid-feedback">
                                <div *ngIf="g.slabId.errors.required">Slab is required</div>
                            </div>
                </div>
             
            </div>
        </div>

        <div class="col-xl-3">
             <label class="fw-bold">Total MMU Incentive Amount <span class="text-danger">*</span> </label>
          <input type="number"
                 class="form-control form-control-sm"
                 formControlName = "totalAmount"
                 [ngClass]="{ 'is-invalid': submitted && g.totalAmount.errors }">
                   <div *ngIf="submitted && g.totalAmount.errors" class="invalid-feedback">
                    <div *ngIf="g.totalAmount.errors.required">Total Amount is required</div>
                    </div>
        </div>
        <div class="col-xl-3">
             <label class="fw-bold"> {{incentiveForm.get('roleName')?.value}} Percentage Amount<span class="text-danger">*</span> </label>
          <input type="number"
                 class="form-control form-control-sm"
                 formControlName = "incentiveAmount"
                 [ngClass]="{ 'is-invalid': submitted && g.incentiveAmount.errors }">
                   <div *ngIf="submitted && g.incentiveAmount.errors" class="invalid-feedback">
                    <div *ngIf="g.incentiveAmount.errors.required">Amount is required</div>
                    </div>
        </div>
        
      <div class="col-xl-3">
                    <div class="form-group">
                        <label class="control-label">Description <span class="text-danger">*</span> </label>
                        <div>
                            <select formControlName="slabDescriptionId" id="slabDescriptionId" class="form-control form-control-sm"
                                 (change)="selectDesc($event.target.value)"
                                [ngClass]="{ 'is-invalid': submitted && g.slabDescriptionId.errors }">
                                <option value="">Select</option>
                                <option *ngFor="let desc of descriptionList" [value]="desc.id">
                                    {{desc.description}}</option>
                            </select>
                            <div *ngIf="submitted && g.slabDescriptionId.errors" class="invalid-feedback">
                                <div *ngIf="g.slabDescriptionId.errors.required">Description is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                            
        </div>
    </div>
       </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-success" (click)="incentivesSubmit()">Save</button>
        <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
  </div>
<div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" 
  id="userWiseView" role="dialog" aria-labelledby="edit">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title"> {{ selectedUser?.userName }} - Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="font-size: small;">
        <div class="container-fluid" >
        <div *ngFor="let role of filteredRoles">

          <!-- 🔴 DEDUCTIONS -->
          <h5 class="text-danger">
            {{ role.roleName | titlecase }} - Deduction
          </h5>

          <table datatable class="table table-striped table-bordered table-sm"
                 *ngIf="role.deductions.length > 0">

            <thead>
              <tr>
                <th>S.No</th>
                <th>Date</th>
                <th>KRA</th>
                <th>KPI</th>
                <th>Deduction Amount</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let d of role.deductions; let i = index">
                <td>{{ i+1 }}</td>
                <td>{{ d.createdOn | date:'dd-MM-yyyy' }}</td>
                <td>{{ d.kraName }}</td>
                <td>{{ d.kpiName }}</td>
                <td class="text-danger text-right">₹{{ d.deductionAmount }}</td>
                <td>{{ d.isBlock ? 'Block' : 'Un Block' }}</td>
              </tr>
            </tbody>

          </table>

          <p *ngIf="role.deductions.length === 0">
            No Deduction Records
          </p>

          <!-- 🟢 INCENTIVES -->
          <h5 class="text-success mt-3">
            {{ role.roleName | titlecase }} - Incentives
          </h5>

          <table datatable class="table table-striped table-bordered table-sm"
                 *ngIf="role.incentives.length > 0">

            <thead>
              <tr>
                <th>S.No</th>
                <th>Date</th>
                <th>Description</th>
                <th>Incentive Amount</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let i of role.incentives; let j = index">
                <td>{{ j+1 }}</td>
                <td>{{ i.createdOn | date:'dd-MM-yyyy' }}</td>
                <td>{{ i.description }}</td>
                <td class="text-success text-right">₹{{ i.incentiveAmount }}</td>
              </tr>
            </tbody>

          </table>

          <p *ngIf="role.incentives.length === 0">
            No Incentive Records
          </p>

        </div>

      </div>
       </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
  </div>
